import { defaultFontSize } from '../constants/font';
import round from './round';

export const px = value => `${round(value / defaultFontSize, 3)}rem`;
